<div class="p-3 text-truncate"><b>{{part.quantityAvailable}} Available</b> - {{branch?.code + ' - ' + branch?.displayName}}</div>
<div class="row g-0" style="width: 17rem; margin: auto">
  <a id="partCardItem_a_ProductImage{{idSuffix}}" class="col-6 product-image product-image-sm"
    [routerLink]="isInModal ? null : ['/parts']"
    [queryParams]="isInModal ? null : {searchTerm:part.rushPartNumber,partId:part.partId}"
    [class.cursor-pointer]="isInModal"
    (click)="onImageClick($event)"
    tabindex="-1">
    <img [src]="getImage(part.image, imageBaseUrl, '100X100')" [default]="'assets/img/100X100_No_Image.png'" tabindex="-1" alt="No Image" >
  </a>
  <div class="col-6 d-flex flex-wrap align-items-center">
    <pricing [part]="part" (partChange)="onPartChange($event);" [priceAdjust]="allowPriceAdjust" [branch]="branch" (extend)="onExtendPart($event)" [displayType]="displayType"></pricing>
  </div>
</div>
@if (part.corePrice) {
  <div id="partCardItem_div_CorePrice{{idSuffix}}" class="p-3">
    <select id="partCardItem_select_CoreOption{{idSuffix}}" class="form-control"
      [(ngModel)]="part.coreOption" [disabled]="!(canReturnCore$ | async)"
      (ngModelChange)="onCoreOptionChange()">
      @if (displayType === 'back-counter-tool') {
        <option id="partCartItem_option_Empty{{idSuffix}}" value="" selected disabled hidden>Select Core Option</option>
      }
      <option id="partCartItem_option_DetailNoCoreReturned{{idSuffix}}" value="NOCORER">No Core Returned</option>
      <option id="partCartItem_option_DetailCoreReturned{{idSuffix}}" value="CORE1">Core Returned</option>
    </select>
  </div>
}
